import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternSatisfactionBlueprint = [
  {
    type: 'outer',
    key: 'directions',
    class_name: 'flex_row',
    blocks: [
      {
        type: 'span',
        div: 1,
        text: 'To whom it may concern:\nThank you for offering internships to Taiwan Tech students! Your support allows tremendous growth opportunities for students. Taiwan Tech uses this questionnaire to evaluate student performance and your level of satisfaction with the intern during their internship. The data collected is aggregated by the school for future reference and planning. All the answers you provide are analyzed in a bulk analysis. Any personal data you provide will not be published or used for any other purpose. Please feel free to answer the questions honestly. Thank you for your cooperation and assistance.',
      },
      {
        type: 'span',
        text: 'Sincerely,\nNational Taiwan University\nof Science and Technology',
      },
      {
        type: 'span',
        text: '',
      },
    ],
  },
  {
    type: 'section_title',
    text: 'Information',
  },
  {
    type: 'input',
    key: 'enterprise_name',
    div: 3,
    disabled: true,
    required: true,
    label: 'Business Name:',
    max_length: 500,
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'filling_date',
    div: 3,
    label: 'Date:',
    icon: 'date',
    check: (cur_val) => {
      if(!cur_val) return '必填';
    },
  },
  {
    type: 'input',
    key: 'company_scorer',
    div: 3,
    required: true,
    label: 'Evaluator Name:',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'company_role',
    div: 3,
    required: true,
    label: 'Occupation:',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    required: true,
    label: 'Intern Name:',
    max_length: 500,
  },
  {
    type: 'select',
    key: 'department_id',
    div: 3,
    disabled: true,
    label: 'Department:',
  },
  {
    type: 'outer',
    div: 3,
    blocks: [
      {
        type: 'label',
        text: 'Internship Period:',
      },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'start_time',
        icon: 'date',
        check: (cur_val) => {
          if(!cur_val) return '必填';
        },
      },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'end_time',
        icon: 'date',
        check: (cur_val) => {
          if(!cur_val) return '必填';
        },
      },
    ],
  },
  {
    type: 'textarea',
    key: 'intern_content',
    div: 'grow',
    required: true,
    max_length: 500,
    label: 'Internship Job Description:',
  },
  {
    type: 'section_title',
    text: 'Satisfaction survey',
  },
  {
    type: 'radio_table',
    key: 'check',
    required: true,
    options: ['Very Satisfied', 'Satisfied', 'Neutral', 'Dissatisfied', 'Very Dissatisfied'],
    values: [5, 4, 3, 2, 1],
    items: [
      '1. Attendance',
      '2. Attitude and Positiveness',
      '3. Ability to Accomplish Tasks',
      '4. Interpersonal Relationships with Co-workers',
      '5. Interpersonal Relationships with Supervisor',
      '6. Ability to Handle Adversity',
      '7. Quality and Efficiency of Work',
      '8. Teamwork Skills',
      '9. Verbal Communication Skills',
      '10.Written Communication Skills',
      '11.Creativity',
      '12.Organizational Skills',
      '13.Appearance and Professionalism',
      '14.Integrity',
      '15.General Satisfaction with Intern',
      '16.Willingness to continue cooperation with Taiwan Tech<br>and provide additional opportunities for other interns.',
      '17.Willingness to offer the intern a full time job',
    ],
  },
  {
    type: 'section_title',
    text: 'Other comments:',
  },
  {
    type: 'textarea',
    key: 'opinion_share',
    max_length: 500,
  },
  {
    type: 'span',
    div: 1,
    text: 'Thanks for filling out the questionnaire and have a good day!',
  },
];
